import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Textarea } from '../components/ui/textarea';
import { ArrowLeft, Save, X, Building2, Phone, Mail, MapPin, User, Calendar } from 'lucide-react';

const ProviderEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [providerData, setProviderData] = useState({
    id: id,
    name: 'Dr. Gerard Nikodem',
    phone: '(636) 937-9133',
    email: 'gcniko@aol.com',
    practice: 'Gerard Nikodem',
    address: '1121 West Gannon Drive, Festus, Missouri, 63028',
    specialty: 'General Dentist',
    referralCount: 237,
    birthday: 'May 4th',
    lastReferral: '10/22/2025',
    notes: 'Preferred provider for complex cases. Excellent communication.',
    claimed: false
  });

  const handleSave = () => {
    console.log('Saving provider data:', providerData);
    alert('Provider information updated successfully!');
    navigate('/doctors');
  };

  const handleCancel = () => {
    navigate('/doctors');
  };

  return (
    <div className="max-w-4xl mx-auto">
      <div className="flex items-center justify-between mb-6">
        <Button variant="ghost" onClick={handleCancel}>
          <ArrowLeft className="h-4 w-4 mr-2" />
          Back to Directory
        </Button>
        <div className="flex space-x-2">
          <Button
            className="bg-[#D4AF37] text-[#0A1628] hover:bg-[#C19B2B]"
            onClick={handleSave}
          >
            <Save className="h-4 w-4 mr-2" />
            Save Changes
          </Button>
          <Button variant="outline" onClick={handleCancel}>
            <X className="h-4 w-4 mr-2" />
            Cancel
          </Button>
        </div>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center">
            <Building2 className="h-6 w-6 mr-2 text-[#D4AF37]" />
            Edit Provider Information
          </CardTitle>
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2 flex items-center">
                <User className="h-4 w-4 mr-1" />
                Provider Name
              </label>
              <Input
                value={providerData.name}
                onChange={(e) => setProviderData({...providerData, name: e.target.value})}
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Practice Name</label>
              <Input
                value={providerData.practice}
                onChange={(e) => setProviderData({...providerData, practice: e.target.value})}
              />
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2 flex items-center">
                <Phone className="h-4 w-4 mr-1" />
                Phone Number
              </label>
              <Input
                value={providerData.phone}
                onChange={(e) => setProviderData({...providerData, phone: e.target.value})}
              />
            </div>
            <div>
              <label className="block text-sm font-medium mb-2 flex items-center">
                <Mail className="h-4 w-4 mr-1" />
                Email Address
              </label>
              <Input
                type="email"
                value={providerData.email}
                onChange={(e) => setProviderData({...providerData, email: e.target.value})}
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2 flex items-center">
              <MapPin className="h-4 w-4 mr-1" />
              Address
            </label>
            <Input
              value={providerData.address}
              onChange={(e) => setProviderData({...providerData, address: e.target.value})}
            />
          </div>

          <div className="grid md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-2">Specialty</label>
              <select 
                className="w-full px-3 py-2 border rounded-md"
                value={providerData.specialty}
                onChange={(e) => setProviderData({...providerData, specialty: e.target.value})}
              >
                <option>General Dentist</option>
                <option>Orthodontist</option>
                <option>Periodontist</option>
                <option>Endodontist</option>
                <option>Oral Surgeon</option>
                <option>Pediatric Dentist</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2 flex items-center">
                <Calendar className="h-4 w-4 mr-1" />
                Birthday
              </label>
              <Input
                value={providerData.birthday}
                onChange={(e) => setProviderData({...providerData, birthday: e.target.value})}
                placeholder="e.g., May 4th"
              />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium mb-2">Notes</label>
            <Textarea
              value={providerData.notes}
              onChange={(e) => setProviderData({...providerData, notes: e.target.value})}
              rows={4}
              placeholder="Add notes about this provider..."
            />
          </div>

          <div className="pt-4 border-t">
            <div className="grid md:grid-cols-3 gap-4 text-center">
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Total Referrals</p>
                <p className="text-2xl font-bold text-[#0A1628]">{providerData.referralCount}</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Last Referral</p>
                <p className="text-lg font-semibold text-[#D4AF37]">{providerData.lastReferral}</p>
              </div>
              <div className="p-4 bg-gray-50 rounded-lg">
                <p className="text-sm text-gray-600 mb-1">Profile Status</p>
                <p className="text-lg font-semibold text-blue-600">
                  {providerData.claimed ? 'Claimed' : 'Unclaimed'}
                </p>
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProviderEdit;